var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonalPhone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 28.65,
    viewBox: "0 0 24 28.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "phone_icon",
    "data-name": "phone icon",
    transform: "translate(-152.639 -66.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_236787",
    "data-name": "Path 236787",
    d: "M170.612,94.617a4,4,0,0,0,.523.034,4.1,4.1,0,0,0,2.421-.8l2.136-1.559h0a1.429,1.429,0,0,0,.241-2.089l-3.841-4.453a1.44,1.44,0,0,0-1.8-.308l-1.972,1.128h0a1.437,1.437,0,0,1-.952.178c-1.147-.2-3.418-1-5.736-4.162s-2.4-5.561-2.242-6.712a1.422,1.422,0,0,1,.458-.851l1.675-1.533a1.431,1.431,0,0,0,.251-1.807l-3.1-5a1.438,1.438,0,0,0-2.07-.4l-2.136,1.558a4.05,4.05,0,0,0-1.623,2.564c-.484,2.719-.535,8.316,4.562,15.261s10.457,8.591,13.2,8.955ZM153.8,70.57a3.089,3.089,0,0,1,1.241-1.954l2.136-1.559a.468.468,0,0,1,.674.131l3.093,5a.466.466,0,0,1-.082.588l-1.675,1.533a2.39,2.39,0,0,0-.763,1.432c-.177,1.295-.1,3.979,2.421,7.412s5.06,4.32,6.351,4.543a2.407,2.407,0,0,0,1.6-.29l1.972-1.128a.468.468,0,0,1,.587.1l3.841,4.453a.465.465,0,0,1-.078.68l-2.136,1.559h0a3.11,3.11,0,0,1-2.243.588c-2.591-.343-7.666-1.91-12.55-8.567S153.342,73.136,153.8,70.57Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236788",
    "data-name": "Path 236788",
    d: "M602.445,152.626a9.65,9.65,0,0,1,8.679,11.863.41.41,0,0,0,.305.492.4.4,0,0,0,.094.011.409.409,0,0,0,.4-.316,10.469,10.469,0,0,0-9.414-12.866.41.41,0,0,0-.062.817Z",
    transform: "translate(-435.568 -83.854)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236789",
    "data-name": "Path 236789",
    d: "M593.269,269.2a6.987,6.987,0,0,1,6.286,8.591.41.41,0,0,0,.3.492.4.4,0,0,0,.095.011.41.41,0,0,0,.4-.316,7.807,7.807,0,0,0-7.022-9.6.41.41,0,1,0-.062.817Z",
    transform: "translate(-426.588 -196.388)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236790",
    "data-name": "Path 236790",
    d: "M584.7,385.845a4.324,4.324,0,0,1,3.891,5.319.41.41,0,0,0,.3.494.418.418,0,0,0,.1.012.41.41,0,0,0,.4-.314,5.144,5.144,0,0,0-4.63-6.328.41.41,0,1,0-.058.817Z",
    transform: "translate(-419.488 -309.98)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalPhone);
export default __webpack_public_path__ + "static/media/personalPhone.ff80c58408ea52e20fa667240a5ac50c.svg";
export { ForwardRef as ReactComponent };